export default "__VITE_ASSET__BxzWJfcP__"